<app-question-template [form]="form" [question]="question">
	@if (isV2()) {
		<button type="button" class="action-panel" (click)="scan()">
			@if (answer?.answers?.length === 1) {
				<span class="material-symbols-outlined material-symbols-outlined--size-24 action-panel-success" aria-hidden="true">
					check_circle
				</span>
				<span class="action-panel-label action-panel-label--filled">
					{{ "CHECKLISTS__QUESTIONS__SCAN__SCANNED" | transloco }}
				</span>
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					qr_code_scanner
				</span>
			} @else {
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					qr_code_scanner
				</span>
				<span class="action-panel-label">{{ "CHECKLISTS__QUESTIONS__SCAN__SCAN" | transloco }}</span>
			}
		</button>
	} @else {
		<div class="checkmark-container">
			<ion-icon *ngIf="answer?.answers?.length === 1" name="checkmark-circle-outline"></ion-icon>
		</div>

		<div class="button-container">
			<ion-button shape="round" (click)="scan()">
				<ion-label>{{ "CHECKLISTS__QUESTIONS__SCAN__SCAN" | transloco }}</ion-label>
				<ion-icon name="scan-outline" slot="end"></ion-icon>
			</ion-button>
		</div>
	}
</app-question-template>
